import 'prismjs';
import 'prismjs/themes/prism.css';

import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
// @ts-ignore
import { PrismCode } from 'react-prism';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import classnames from 'classnames';

import ButtonCopyToClipboard from './ButtonCopyToClipboard';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      border: `1px solid ${theme.custom.palette.colorSupportPowder}`,
      // WORKAROUND: `!important` needed due to `prism` overriding the styles
      fontSize: `${theme.custom.fontSizes.small}px !important`,
      background: 'none !important',
    },
    btnCopy: {
      position: 'absolute',
      right: 16,
    },
  });

const messages = defineMessages({
  btnCopyLabel: {
    id: 'components.v2.EmbedCode.btnCopyLabel',
    defaultMessage: 'Copy Code',
  },
});

export interface EmbedCodeProps extends WithStyles<typeof styles> {
  children: string;
  className?: string;
}

const EmbedCode: React.FC<EmbedCodeProps> = ({ classes, className, children }) => {
  const { formatMessage } = useIntl();

  return (
    <pre className={classnames(classes.root, className)}>
      <ButtonCopyToClipboard
        className={classes.btnCopy}
        text={children}
        variant="outlined"
        color="primary"
        size="small"
      >
        {formatMessage(messages.btnCopyLabel)}
      </ButtonCopyToClipboard>
      <PrismCode className="language-markup">{children}</PrismCode>
    </pre>
  );
};

export default withStyles(styles)(EmbedCode);
